import { default as longTextIconSmall } from './field-longtext-small.es6';

// TODO: Create small version of StructuredText field icon instead.
export default longTextIconSmall;



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-structuredtext-small.es6.js